import { isMobile } from 'react-device-detect';

export const MY_EVENTS = 'MY';
export const UPCOMING_EVENTS = 'UPCOMING';
export const LIVE_EVENTS = 'LIVE';
export const FAVORITE_EVENTS = 'FAVORITE';
export const COMPLETED_EVENTS = 'COMPLETED';
export const DEFAULT_FEEDS_PAGE_SIZE = isMobile ? 10 : 16;
